module.exports = __webpack_public_path__ + "img/2.eff5cfdc.png";